var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIconStep2Bottom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.997,
    height: 127.249,
    viewBox: "0 0 68.997 127.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812",
    transform: "translate(-164.872 -891.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-15124.5,127.249a4.5,4.5,0,0,1-4.5-4.5v-70a4.486,4.486,0,0,1,.062-.756V0l34.6,21.73V12.082h23V36.174l11.27,7.076v8.744a4.486,4.486,0,0,1,.061.756v70a4.5,4.5,0,0,1-4.5,4.5Z",
    transform: "translate(15293.871 891.919)",
    fill: "#e3e7ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2461",
    "data-name": "Rectangle 2461",
    width: 18.298,
    height: 18.298,
    transform: "translate(192.487 943.023)",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2462",
    "data-name": "Rectangle 2462",
    width: 18.298,
    height: 18.298,
    transform: "translate(192.487 977.956)",
    fill: "#f4f6f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIconStep2Bottom);
export default __webpack_public_path__ + "static/media/footer-icon-step2-bottom.7cda2acb.svg";
export { ForwardRef as ReactComponent };